// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { PrimaryTemplate } from 'components/templates/PrimaryTemplate';
import CompressionAcceptancesScreen from 'components/organisms/CompressionAcceptances';

import { useTranslation } from 'react-i18next';

const CompressionAcceptances = () => {
  const { t } = useTranslation();

  return (
    <div>
      <PrimaryTemplate h1={t('compression_acceptance.title')}>
        <CompressionAcceptancesScreen />
      </PrimaryTemplate>
    </div>
  );
};

export default CompressionAcceptances;
